import { render, staticRenderFns } from "./ChatLog.vue?vue&type=template&id=a4704e54"
import script from "./ChatLog.vue?vue&type=script&lang=js"
export * from "./ChatLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports